import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { AuthDialog } from "@/components/AuthDialog";
import { PlanetDossier } from "@/components/PlanetDossier";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function SharedPlanet() {
  const { token } = useParams();
  const { user } = useAuth();
  const [planet, setPlanet] = useState(null);
  const [error, setError] = useState("");
  const [authOpen, setAuthOpen] = useState(false);

  useEffect(() => {
    if (user === null) return;
    api.get(`/shared/${token}`).then((r) => setPlanet(r.data)).catch((e) => setError(errMsg(e)));
  }, [token, user]);

  return (
    <div className="relative z-10 min-h-screen" data-testid="shared-planet-page">
      <Header onSignIn={() => setAuthOpen(true)} />
      <main className="mx-auto max-w-7xl px-4 sm:px-6 py-10">
        <div className="glass rounded-full px-5 py-2.5 inline-flex items-center gap-3 mb-8" data-testid="shared-banner">
          <span className="h-2 w-2 rounded-full bg-[#00FF66] animate-pulse" />
          <span className="label-mono">Shared transmission</span>
          {!user && <button onClick={() => setAuthOpen(true)} className="font-mono text-xs text-cyan-300 hover:text-white transition-colors" data-testid="shared-signin-link">Sign in to save & react</button>}
          {user && <Link to="/universe" className="font-mono text-xs text-cyan-300 hover:text-white transition-colors" data-testid="shared-go-universe-link">Open your sector map</Link>}
        </div>
        {error && <p className="glass rounded-xl p-8 text-[#FF5500] font-mono text-sm" data-testid="shared-error">{error}</p>}
        {!planet && !error && <p className="label-mono animate-pulse">Receiving transmission…</p>}
        {planet && <PlanetDossier planet={planet} setPlanet={setPlanet} reveal onNeedAuth={() => setAuthOpen(true)} />}
      </main>
      <AuthDialog open={authOpen} onClose={() => setAuthOpen(false)} redirectTo={`/p/${token}`} />
    </div>
  );
}
